// Avisos do renderer: sempre no console (inclusive em produção), uma vez por mensagem.
const seen = new Set()

export const warn = (message, detail) => {
	if (seen.has(message)) return
	seen.add(message)
	const args = detail === undefined ? [ `[Tiptap] ${message}` ] : [ `[Tiptap] ${message}`, detail ]
	// eslint-disable-next-line no-console
	console.warn(...args)
}

// Só para os scripts de verificação do plano (fora do repositório); o site não chama.
// Sem ele, um aviso já emitido num caso de teste some dos casos seguintes
export const resetWarnings = () => seen.clear()
